import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { Portal } from 'components/Portal/Portal';
import { useTranslation } from 'react-i18next';

type UserTermiateModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
};
export const UserTermiateModal: React.FC<UserTermiateModalProps> = ({ isOpen, onClose, onConfirm }) => {
    const { t } = useTranslation('member', { keyPrefix: 'userSettings' });

    return (
        <Portal>
            <Modal isOpen={isOpen} onClose={onClose} maxWidth={512} uncloseable>
                <div className="flex flex-col gap-4">
                    <div>
                        <div className="text-xl font-semibold text-zinc-700 mb-2">{t('terminateModalTitle')}</div>
                        <div className="text-sm text-zinc-500">{t('terminateModalSubtitle')}</div>
                    </div>
                    <div className="flex justify-end gap-2">
                        <Button variant="outline" onClick={onClose}>
                            {t('cancelModalButton')}
                        </Button>
                        <Button onClick={onConfirm}> {t('yesModalButton')}</Button>
                    </div>
                </div>
            </Modal>
        </Portal>
    );
};
